import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=211f9c0c&scoped=true&"
import script from "./SupportPage.vue?vue&type=script&lang=ts&"
export * from "./SupportPage.vue?vue&type=script&lang=ts&"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=211f9c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f9c0c",
  null
  
)

export default component.exports